import React from "react"
// import {
//   QuickInputScreen,
// } from "../../screens"
// import { createNativeStackNavigator } from "@react-navigation/native-stack"
import { createStackNavigator } from "@react-navigation/stack"

export type QuickInputNavigatorParamList = {
  'QuickInput.QuickInput': undefined
}

// const Stack = createNativeStackNavigator<QuickInputNavigatorParamList>()
const Stack = createStackNavigator<QuickInputNavigatorParamList>()

export const QuickInputStack = {
  index: 0,
  routes: [
    { name: 'QuickInput.Stack', state: { index: 0, routes: [{ name: 'QuickInput.QuickInput' }] } }
  ]
};

export const QuickInputNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        cardStyle: { flex: 1 },
        headerShown: false,
        headerBackTitleVisible: false,
        headerTitleAlign: "left",
        headerTitleContainerStyle: { marginLeft: 0 }
      }}
      // initialRouteName="QuickInput.QuickInput"
    >
      {/* <Stack.Screen name="QuickInput.QuickInput" component={QuickInputScreen} /> */}
    </Stack.Navigator>
  )
}
